module.exports = __webpack_public_path__ + "static/media/Prestaciones.a82425a0.svg";